// extracted by mini-css-extract-plugin
export default {"paranja":"PreviewRadio_paranja__0KjqN","imagePlaceholder":"PreviewRadio_imagePlaceholder__aIYvY"};